import React, { useState, useEffect } from "react";
import { Configurations } from "../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import './Cile-Kits.scss';
import axios from "axios";
import CileKitCards from "../../Components/Cile-Kits/Cile-Kit-Card";

const CileKits = () => {

    const [loading, setLoading] = useState(true)
    const [openModalKit, setOpenModalKit] = useState(false)
    const [openModalKitAnterior, setOpenModalKitAnterior] = useState(false)
    const [kits, setKits] = useState([])
    const [novoItem, setNovoItem] = useState('')
    const [skuNovo, setSkuNovo] = useState()
    const [precoNovo, setPrecoNovo] = useState(0)
    const [nomeNovo, setNomeNovo] = useState('')
    const [skuKitNovo, setSkuKitNovo] = useState()
    const [kitBase, setKitBase] = useState()

    useEffect(() => {
        chamadaKits()
    }, [])

    const chamadaKits = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/kits-cile/lista`)
            .then(response => {
                setKits(response.data)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const buscaSKU = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/kits-cile/produto/${skuNovo}`)
            .then(response => {
                setNovoItem(response.data.produto[0]);
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setNovoItem('Item não encontrado')
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const novoKit = () => {
        setLoading(true);
        const config = new Configurations();
        const valorCorrigido = precoNovo.replace(/,/g, ".");
        const body = {
            nomeKit: nomeNovo,
            skuKit: Number(skuKitNovo),
            itens: [
                {
                    skuItem: Number(skuNovo),
                    preco: Number(valorCorrigido)
                }
            ]
        }
        axios.post(config.apiBasePath + `/kits-cile/novo-kit`, body)
            .then(response => {
                setLoading(false);
                setKits(response.data)
                toggleModal();
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoading(false);
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const novoKitAnterior = () => {
        setLoading(true);
        const config = new Configurations();
        const body = {
            skuKit: Number(skuKitNovo),
            nomeKit: nomeNovo,
            skuKitBase: Number(kitBase)
        }
        axios.post(config.apiBasePath + `/kits-cile/gerar-kit-anterior`, body)
            .then(response => {
                setKits(response.data)
                setLoading(false);
                toggleModalAnterior()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoading(false);
            })
            .finally(() => {
                setLoading(false)
            });
    }


    const toggleModal = () => {
        setOpenModalKit(!openModalKit)
    }

    const toggleModalAnterior = () => {
        setOpenModalKitAnterior(!openModalKitAnterior)
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "skuNovo") {
            setSkuNovo(value);
        } else if (name === "precoNovo") {
            setPrecoNovo(value);
        } else if (name === "nomeNovo") {
            setNomeNovo(value);
        } else if (name === "skuKitNovo") {
            setSkuKitNovo(value);
        }
    };

    useEffect(() => {
        if (!openModalKit) {
            setSkuNovo();
            setPrecoNovo();
            setNovoItem('');
            setNomeNovo('');
            setSkuKitNovo();
        }
    }, [openModalKit]);

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">CILE - Kits</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" type="button" onClick={() => toggleModal()}>
                                Novo Kit
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="no-gutters align-items-center pb-3 px-lg-3">


                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <>
                            <div className="row no-gutters">
                                <div className="col-4">
                                    <h3 className="mt-4 mb-3 border-primary border-bottom">
                                        Planos
                                    </h3>
                                </div>

                                {kits && kits.planos.map((item) => (
                                    <CileKitCards 
                                    setSkuNovo={setSkuNovo} 
                                    skuNovo={skuNovo} 
                                    setPrecoNovo={setPrecoNovo} 
                                    precoNovo={precoNovo} 
                                    setKitBase={setKitBase} 
                                    toggleModalAnterior={toggleModalAnterior} 
                                    plano={true} 
                                    response={item} 
                                    key={item.skuKit} 
                                    
                                     />
                                ))}

                                <div className="col-4">
                                    <h3 className="mt-5 mb-4 border-primary border-bottom">
                                        Kits Prontos / Anteriores
                                    </h3>
                                </div>
                                {kits && kits.anteriores.map((item) => (
                                    <CileKitCards 
                                    setSkuNovo={setSkuNovo} 
                                    skuNovo={skuNovo} 
                                    setPrecoNovo={setPrecoNovo} 
                                    precoNovo={precoNovo} 
                                    setKitBase={setKitBase} 
                                    toggleModalAnterior={toggleModalAnterior} 
                                    plano={false} 
                                    response={item} 
                                    key={item.skuKit} 
                                    
                                     />
                                ))}
                            </div>
                        </>
                    }
                </div>
            </div>

            <Modal size="lg" isOpen={openModalKit} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Novo Kit
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-8'>
                            <label>Nome do Kit:</label>
                            <input name="nomeNovo" type="text" className="form-control" autoComplete="off" value={nomeNovo} onChange={handleInputChange} />
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mt-4">
                            <p className="mt-3">SKU do Kit:</p>
                            <input name="skuKitNovo" type="text" className="form-control w-50 ml-2" autoComplete="off" value={skuKitNovo} onChange={handleInputChange} />
                        </div>
                        <div className="col-12 mt-3">
                            <small>* Necessário adicionar 1 item para gerar o kit.</small>
                        </div>
                        <div className="col-3 d-flex align-items-center mt-3">
                            <p className="mt-3">SKU Item:</p>
                            <input name="skuNovo" type="text" className="form-control w-50 ml-2" autoComplete="off" value={skuNovo} onChange={handleInputChange} />
                        </div>
                        <div className="col-1 d-flex justify-content-end align-items-center mt-3">
                            <button className='btn btn-sm btn-outline-primary ml-3' disabled={!skuNovo} onClick={() => buscaSKU()}>
                                Buscar
                            </button>
                        </div>
                        <div className="col-7 d-flex justify-content-center align-items-center mt-3">
                            <p className="mt-3">{novoItem && novoItem.nome ? novoItem.nome : novoItem}</p>
                        </div>
                        {novoItem && novoItem.nome && (
                            <>
                                <div className="col-3 d-flex align-items-center mt-3">
                                    <p className="mt-3">Preço:</p>
                                    <input name="precoNovo" type="text" className="form-control w-50 ml-2" autoComplete="off" value={precoNovo} onChange={handleInputChange} />
                                </div>
                                <div className="col-9 d-flex align-items-center mt-3">
                                    <small>*Inserir somente números</small>
                                </div>
                            </>
                        )}
                    </div>

                </ModalBody>

                <ModalFooter>
                    <div className='justify-content-between d-flex w-100'>
                        <button className='btn btn-sm btn-outline-danger' onClick={() => toggleModal()} >
                            Cancelar
                        </button>
                        <button className='btn btn-sm btn-outline-success' onClick={() => novoKit()} >
                            Salvar
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <Modal isOpen={openModalKitAnterior} toggle={toggleModalAnterior}>
                <ModalHeader toggle={toggleModalAnterior}>
                    Novo Kit Anterior
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-8'>
                            <label>Nome do novo kit:</label>
                            <input name="nomeNovo" type="text" className="form-control" autoComplete="off" value={nomeNovo} onChange={handleInputChange} />
                        </div>
                        <div className="col-4 ">
                            <label>SKU do novo kit:</label>
                            <input name="skuKitNovo" type="text" className="form-control" autoComplete="off" value={skuKitNovo} onChange={handleInputChange} />
                        </div>
                    </div>

                </ModalBody>

                <ModalFooter>
                    <div className='justify-content-between d-flex w-100'>
                        <button className='btn btn-sm btn-outline-danger' onClick={() => toggleModalAnterior()} >
                            Cancelar
                        </button>
                        <button className='btn btn-sm btn-outline-success' onClick={() => novoKitAnterior()} >
                            Salvar
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

        </div>
    )
}


export default CileKits;